import Vue from 'vue'
import Router from 'vue-router'
import mainHome from '../view/mainHome'
import home from '../view/home'
import rentPrivate from '../view/rentPrivate'
import rentReal from "../view/rentReal.vue";
import login from "../view/login.vue";
import profile from "../view/profile.vue";
import rentPrivateDetail from "../view/rentPrivateDetail.vue";
import register from "../view/register.vue";
import edit from "../view/edit.vue";
import countryList from "../view/countryList.vue";
import message from "../view/message.vue";
import records from "../view/records.vue";
import orderList from "../view/orderList.vue";
import blog from "../view/blog.vue";
import BalanceDetails from "../view/BalanceDetails.vue";
import contact from "../view/contact.vue";
import provision from "../view/provision.vue";
import problem from "../view/problem.vue";
import success from "../view/success.vue";
import cancel from "../view/cancel.vue";
import forgotPassword from "../view/forgotPassword.vue";
import boxMain from "../view/boxMain.vue";
import search from "../view/search.vue";
import productDetail from "../view/productDetail.vue";
import changciDetail from "../view/changciDetail.vue";
import result from "../view/result.vue";
import faxian from "../view/faxian.vue";
import faxianDetail from "../view/faxianDetail.vue";
import about from "../view/about.vue";
import tupian from "../view/tupian.vue"

Vue.use(Router)
//配置路由重复跳转
const original = Router.prototype.push
Router.prototype.push = function push(location) {
  return original.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'boxMain',
      component: boxMain,
      redirect: 'home',
      children:[
        {
          path: '/home',
          name: 'home',
          component: home
        },{
          path: '/blog',
          name: 'blog',
          component: blog
        },{
          path: '/search',
          name: 'search',
          component: search
        },{
          path: '/productDetail',
          name: 'productDetail',
          component: productDetail
        },{
          path: '/message',
          name: 'message',
          component: message
        },{
          path: '/contact',
          name: 'contact',
          component: contact
        },{
          path: '/changciDetail',
          name: 'changciDetail',
          component: changciDetail
        },{
          path: '/result',
          name: 'result',
          component: result
        },{
          path: '/faxian',
          name: 'faxian',
          component: faxian
        },{
          path: '/faxianDetail',
          name: 'faxianDetail',
          component: faxianDetail
        },{
          path: '/about',
          name: 'about',
          component: about
        },{
          path: '/tupian',
          name: 'tupian',
          component: tupian
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js